@if (!enableExternalHyperLink() && !enableRoutingHyperLink() && !linkOnly()) {
  <button [type]="buttonType()"
    class="tw-btn tw-btn-{{ type() }} {{ customClass() }}"
    [class.tw-btn-sm]="size() === 'sm'"
    [class.tw-btn-lg]="size() === 'lg'"
    [class.tw-btn-icon]="iconOnly()"
    [class.tw-btn-circle]="shape() === 'circle'"
    [class.tw-btn-quiet]="quiet()"
    [disabled]="isloading() || disabled() || (permissionTypes() ? !(permissionTypes() | calioPermissionChecker): false)"
    (click)="onClick($event)"
    [attr.id]='buttonId() ? buttonId() : null'
    [attr.aria-label]="iconOnly() ? buttonText() : null"
    [ngStyle]="{
      'height': height(),
      'min-width': minWidth()
    }"
  >
    @if (
      requiredFeatureName() && (requiredFeatureName() | calioFeature) ||
      !requiredFeatureName()
    ) {
      <span class="tw-flex tw-items-center tw-justify-center">
        @if (isloading()) {
          <span class="tw-flex tw-items-center">
            <app-calio-icon iconType="circle-notch" spin="true" />
          </span>
        } @else {
          @if (iconPosition() === 'before') {
            <ng-container [ngTemplateOutlet]="iconBlock" />
          }
          @if (!iconOnly()) {
            <span>{{ buttonText() }}</span>
          }
          @if (iconPosition() === 'after') {
            <ng-container [ngTemplateOutlet]="iconBlock" />
          }
        }
      </span>
    } @else {
      <span class="tw-flex tw-justify-center">
        @if (!iconOnly()) {
          <span>{{ buttonText() }}</span>
        }
        <app-calio-lock-icon
          [class.tw-ml-2]="!iconOnly()"
          [requiredSubscriptionPlan]="requiredFeatureName()"
        />
      </span>
    }
  </button>
}

@if (enableRoutingHyperLink()) {
  <a class="tw-btn tw-btn-{{ type() }} {{ customClass() }} tw-inline-flex tw-items-center"
    [class.tw-btn-sm]="size() === 'sm'"
    [class.tw-btn-lg]="size() === 'lg'"
    [class.tw-btn-icon]="iconOnly()"
    [class.tw-btn-circle]="shape() === 'circle'"
    [class.tw-btn-quiet]="quiet()"
    [attr.aria-label]="iconOnly() ? buttonText() : null"
    (click)="onLinkClick($event)"
    routerLink="{{ url() }}"
    [queryParams]="queryParams()"
    [fragment]="fragment()"
    [ngStyle]="{
      'height': height(),
      'min-width': minWidth()
    }"
  >
    @if (iconPosition() === 'before') {
      <ng-container [ngTemplateOutlet]="iconBlock" />
    }
    @if (!iconOnly()) {
      {{ buttonText() }}
    }
    @if (iconPosition() === 'after') {
      <ng-container [ngTemplateOutlet]="iconBlock" />
    }
  </a>
}

@if (enableExternalHyperLink()) {
  <a class="tw-btn tw-btn-{{ type() }} {{ customClass() }} tw-inline-flex tw-items-center"
    [class.tw-btn-sm]="size() === 'sm'"
    [class.tw-btn-lg]="size() === 'lg'"
    [class.tw-btn-icon]="iconOnly()"
    [class.tw-btn-circle]="shape() === 'circle'"
    [class.tw-btn-quiet]="quiet()"
    [attr.aria-label]="iconOnly() ? buttonText() : null"
    (click)="onLinkClick($event)"
    [href]="url()" [target]="target()"
    [attr.rel]="target() === '_blank' ? 'noopener noreferrer' : null"
    [ngStyle]="{
      'height': height(),
      'min-width': minWidth()
    }"
  >
    @if (iconPosition() === 'before') {
      <ng-container [ngTemplateOutlet]="iconBlock" />
    }
    @if (!iconOnly()) {
      {{ buttonText() }}
    }
    @if (iconPosition() === 'after') {
      <ng-container [ngTemplateOutlet]="iconBlock" />
    }
  </a>
}

@if (linkOnly()) {
  <a [class]="customClass() + ' tw-inline-flex tw-items-center'" [routerLink]="url()" [queryParams]="queryParams()" [target]="target()"
  [attr.aria-label]="iconOnly() ? buttonText() : null"
  (click)="onLinkClick($event)"
  [ngStyle]="{
    'height': height(),
    'min-width': minWidth()
  }"
  >
    @if (iconPosition() === 'before') {
      <ng-container [ngTemplateOutlet]="iconBlock" />
    }
    @if (!iconOnly()) {
      {{ buttonText() }}
    }
    @if (iconPosition() === 'after') {
      <ng-container [ngTemplateOutlet]="iconBlock" />
    }
  </a>
}

<!--
  ONE icon block, shared by all four render modes, so `iconPosition` is honoured
  everywhere rather than only where someone remembered to duplicate the ordering.
  Sharing it also hands the link modes the `iconType` path they never had — passing
  `iconType` to a link previously rendered nothing at all.
  The gap sits on the side facing the label, so it flips with the position.
-->
<ng-template #iconBlock>
  @if (icon()) {
    <span class="tw-flex tw-items-center"
      [class.tw-mr-1]="buttonText() && !iconOnly() && iconPosition() === 'before'"
      [class.tw-ml-1]="buttonText() && !iconOnly() && iconPosition() === 'after'"
    >
      <calio-mat-icon [iconType]="iconName()" [customClass]="iconCustomClass()" height="16px" width="16px" />
    </span>
  }
  @if (iconType()) {
    <span class="tw-flex tw-items-center"
      [class.tw-mr-1]="buttonText() && !iconOnly() && iconPosition() === 'before'"
      [class.tw-ml-1]="buttonText() && !iconOnly() && iconPosition() === 'after'"
    >
      <calio-mat-icon iconType="{{ iconType() }}" customClass="{{ customSvgClass() }}" height="{{ svgHeight() }}" width="{{ svgWidth() }}" fill="{{ svgFill() }}" />
    </span>
  }
</ng-template>
